import { useState, type ReactNode } from 'react';
import { readTheme, saveTheme, type ThemeChoice } from '../lib/theme.js';
import { MonitorIcon, MoonIcon, SunIcon } from '../ui/icons.js';

/**
 * Light, dark, or whatever the system says (P11.4): three buttons, one pressed.
 * Each is labelled for a screen reader, and the pressed one says so.
 */

const CHOICES: { value: ThemeChoice; label: string; Icon: typeof SunIcon }[] = [
  { value: 'system', label: 'Use the system theme', Icon: MonitorIcon },
  { value: 'light', label: 'Light theme', Icon: SunIcon },
  { value: 'dark', label: 'Dark theme', Icon: MoonIcon },
];

export function ThemeSwitch(): ReactNode {
  const [choice, setChoice] = useState<ThemeChoice>(readTheme);
  return (
    <div className="theme-switch" role="group" aria-label="Theme">
      {CHOICES.map(({ value, label, Icon }) => (
        <button
          key={value}
          type="button"
          className="theme-option"
          aria-label={label}
          aria-pressed={choice === value}
          title={label}
          onClick={() => {
            saveTheme(value);
            setChoice(value);
          }}
        >
          <Icon />
        </button>
      ))}
    </div>
  );
}
